import { CALL_API } from '../../common/middleware/api';
import { createChild } from '../actions';
import { initiatePaymentWithMethod, confirmPaymentWithMethod } from './paymentMethods/actions';
import { fetchPayment, PaymentTypes } from '../payments/actions';
import { i18n } from '../../common/services/globalize';
import queryString from 'query-string';
import analyticsTracker from '../../common/services/analyticsTracker';

export const STORE_SEARCH_QUERY = 'STORE_SEARCH_QUERY';
export const STORE_INDIVIDUAL_CONSULTATION_SEARCH_QUERY = 'STORE_INDIVIDUAL_CONSULTATION_SEARCH_QUERY';

export const RESET_BOOKING = 'RESET_BOOKING';
export const BOOKING_OPTIONS_FETCH_REQUEST = 'BOOKING_OPTIONS_GET_REQUEST';
export const BOOKING_OPTIONS_FETCH_SUCCESS = 'BOOKING_OPTIONS_GET_SUCCESS';
export const BOOKING_OPTIONS_FETCH_FAILURE = 'BOOKING_OPTIONS_GET_FAILURE';

export const PAYMENT_METHODS_FETCH_REQUEST = 'PAYMENT_METHODS_GET_REQUEST';
export const PAYMENT_METHODS_FETCH_SUCCESS = 'PAYMENT_METHODS_GET_SUCCESS';
export const PAYMENT_METHODS_FETCH_FAILURE = 'PAYMENT_METHODS_GET_FAILURE';

export const INSTALMENT_PLANS_FETCH_REQUEST = 'INSTALMENT_PLANS_FETCH_REQUEST';
export const INSTALMENT_PLANS_FETCH_SUCCESS = 'INSTALMENT_PLANS_FETCH_SUCCESS';
export const INSTALMENT_PLANS_FETCH_FAILURE = 'INSTALMENT_PLANS_FETCH_FAILURE';

export const UNSELECT_LESSON = 'UNSELECT_LESSON';
export const SELECT_CHILD = 'SELECT_CHILD';
export const SELECT_PAYMENT_TYPE = 'SELECT_PAYMENT_TYPE';
export const SELECT_CONSULTATION_DATE = 'SELECT_CONSULTATION_DATE';
export const SELECT_CENTER = 'SELECT_CENTER';
export const SELECT_JOIN_WAITING_LIST = 'SELECT_JOIN_WAITING_LIST';
export const SELECT_TERM = 'SELECT_TERM';
export const SELECT_GRADE = 'SELECT_GRADE';
export const SELECT_LESSON_TYPE = 'SELECT_LESSON_TYPE';

export const SELECT_PROGRAM_ITEM = 'SELECT_PROGRAM_ITEM';
export const UNSELECT_PROGRAM_ITEM = 'UNSELECT_PROGRAM_ITEM';

export const SELECT_WORKSHOP_SESSIONS = 'SELECT_WORKSHOP_SESSIONS';

export const START_ENROLMENT = 'START_ENROLMENT';
export const START_INDIVIDUAL_CONSULTATION_ENROLMENT = 'START_INDIVIDUAL_CONSULTATION_ENROLMENT';
export const START_WORKSHOP_ENROLMENT = 'START_WORKSHOP_ENROLMENT';

export const WAITING_LIST_JOIN_REQUEST = 'WAITING_LIST_JOIN_REQUEST';
export const WAITING_LIST_JOIN_SUCCESS = 'WAITING_LIST_JOIN_SUCCESS';
export const WAITING_LIST_JOIN_FAILURE = 'WAITING_LIST_JOIN_FAILURE';

export const BOOKING_CREATE_REQUEST = 'BOOKING_CREATE_REQUEST';
export const BOOKING_CREATE_SUCCESS = 'BOOKING_CREATE_SUCCESS';
export const BOOKING_CREATE_FAILURE = 'BOOKING_CREATE_FAILURE';

export const INDIVIDUAL_CONSULTATION_CREATE_REQUEST = 'INDIVIDUAL_CONSULTATION_CREATE_REQUEST';
export const INDIVIDUAL_CONSULTATION_CREATE_SUCCESS = 'INDIVIDUAL_CONSULTATION_CREATE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_CREATE_FAILURE = 'INDIVIDUAL_CONSULTATION_CREATE_FAILURE';

export const WORKSHOP_BOOKING_CREATE_REQUEST = 'WORKSHOP_BOOKING_CREATE_REQUEST';
export const WORKSHOP_BOOKING_CREATE_SUCCESS = 'WORKSHOP_BOOKING_CREATE_SUCCESS';
export const WORKSHOP_BOOKING_CREATE_FAILURE = 'WORKSHOP_BOOKING_CREATE_FAILURE';

export const PAYMENT_START_REQUEST = 'PAYMENT_START_REQUEST';
export const PAYMENT_START_SUCCESS = 'PAYMENT_START_SUCCESS';
export const PAYMENT_START_FAILURE = 'PAYMENT_START_FAILURE';

export const PAYMENT_END_REQUEST = 'PAYMENT_END_REQUEST';
export const PAYMENT_END_SUCCESS = 'PAYMENT_END_SUCCESS';
export const PAYMENT_END_FAILURE = 'PAYMENT_END_FAILURE';

export const PAYMENT_CANCELLED = 'PAYMENT_CANCELLED';	// user cancelled payment on payment provider page or card was declined

export const PAYMENT_CANCEL_REQUEST = 'PAYMENT_CANCEL_REQUEST';
export const PAYMENT_CANCEL_SUCCESS = 'PAYMENT_CANCEL_SUCCESS';
export const PAYMENT_CANCEL_FAILURE = 'PAYMENT_CANCEL_FAILURE';

export const APPLY_PROMO_CODE_REQUEST = 'APPLY_PROMO_CODE_REQUEST';
export const APPLY_PROMO_CODE_SUCCESS = 'APPLY_PROMO_CODE_SUCCESS';
export const APPLY_PROMO_CODE_FAILURE = 'APPLY_PROMO_CODE_FAILURE';

export const REMOVE_PROMO_CODE_REQUEST = 'REMOVE_PROMO_CODE_REQUEST';
export const REMOVE_PROMO_CODE_SUCCESS = 'REMOVE_PROMO_CODE_SUCCESS';
export const REMOVE_PROMO_CODE_FAILURE = 'REMOVE_PROMO_CODE_FAILURE';

export const PAYMENT_METHOD_SELECT_REQUEST = 'PAYMENT_METHOD_SELECT_REQUEST';
export const PAYMENT_METHOD_SELECT_SUCCESS = 'PAYMENT_METHOD_SELECT_SUCCESS';
export const PAYMENT_METHOD_SELECT_FAILURE = 'PAYMENT_METHOD_SELECT_FAILURE';

export const loadBookingOptions = (options) => ({
	[CALL_API]: {
		types: [BOOKING_OPTIONS_FETCH_REQUEST, BOOKING_OPTIONS_FETCH_SUCCESS, BOOKING_OPTIONS_FETCH_FAILURE],
		endpoint: `api/booking`,
		request: options
	}
});

export const loadPaymentMethods = centerId => (dispatch, getState) => {
	const cachedPaymentMethods = getState().booking.paymentMethodsByCenter[centerId];
	if (cachedPaymentMethods) {
		return null;
	}

	return dispatch(fetchPaymentMethods(centerId));
};

const fetchPaymentMethods = centerId => ({
	[CALL_API]: {
		types: [PAYMENT_METHODS_FETCH_REQUEST, PAYMENT_METHODS_FETCH_SUCCESS, PAYMENT_METHODS_FETCH_FAILURE],
		endpoint: `api/booking/payment`,
		request: { centerId }
	},
	centerId
});

export const loadInstalmentPlans = paymentId => ({
	[CALL_API]: {
		types: [INSTALMENT_PLANS_FETCH_REQUEST, INSTALMENT_PLANS_FETCH_SUCCESS, INSTALMENT_PLANS_FETCH_FAILURE],
		endpoint: `api/booking/instalmentPlans/${paymentId}`
	}
});

export const createAndSelectChild = (child, history) => (dispatch, getState) => {
	const childrenCount = getState().parent.children.length;
	dispatch(createChild(child))
		.then(() => {
			const parent = getState().parent;
			const newChild = parent.children[childrenCount];
			if (newChild) {
				dispatch(selectChild(newChild.id));
				history.push('child');  // removes add=true query param and redirects to MedicalInfo or Center as appropriate
			}
		});
};

export const storeSearchQuery = search => (dispatch, getState) => {
	const campaignTags = extractCampaignTagsFromQuery(search);
	if (campaignTags) {
		const { configuration } = getState();
		analyticsTracker.setCampaignTags(configuration.franchisor, campaignTags);
	}

	dispatch({
		type: STORE_SEARCH_QUERY,
		payload: search
	});
};

const extractCampaignTagsFromQuery = query => {
	const queryParams = queryString.parse(query);
	let campaignTags = null;
	const campaignParams = Object.keys(queryParams).filter(x => x.startsWith('utm_'));
	if (campaignParams.length > 0) {
		campaignTags = {};
		campaignParams.forEach(key => {
			campaignTags[key] = queryParams[key];
		});
	}
	return campaignTags;
};

export const storeIndividualConsultationSearchQuery = search => (dispatch, getState) => {
	const campaignTags = extractCampaignTagsFromQuery(search);
	if (campaignTags) {
		const { configuration } = getState();
		analyticsTracker.setCampaignTags(configuration.franchisor, campaignTags);
	}

	dispatch({
		type: STORE_INDIVIDUAL_CONSULTATION_SEARCH_QUERY,
		payload: search
	});
};

export const unselectLesson = () => ({
	type: UNSELECT_LESSON
});

export const selectProgramItem = programItemId => ({
	type: SELECT_PROGRAM_ITEM,
	payload: programItemId
});

export const unselectProgramItem = () => ({
	type: UNSELECT_PROGRAM_ITEM
});

export const resetBooking = () => ({
	type: RESET_BOOKING
});

export const selectChild = childId => ({
	type: SELECT_CHILD,
	payload: childId
});

export const selectPaymentType = ({ paymentTypeId, isPrepaid, isBonusLesson, annualPaymentLength }) => ({
	type: SELECT_PAYMENT_TYPE,
	payload: { paymentTypeId, isPrepaid, isBonusLesson, annualPaymentLength }
});

export const selectWorkshopSessions = workshopSessionIds => ({
	type: SELECT_WORKSHOP_SESSIONS,
	payload: workshopSessionIds
});

export const startEnrolment = ({ centerId, programId, startDate, paymentTypeId, currency, quantity, unitPrice, total, lesson }) => ({
	type: START_ENROLMENT,
	payload: { centerId, programId, startDate, paymentTypeId },
	analytics: [
		{
			event: 'AddToCart',
			data: {
				currency,
				value: total,
				contents: [
					{ id: lesson.grade.id, quantity: quantity }
				],
				content_name: lesson.grade.name,
				num_items: quantity
			},
			platform: 'FB'
		},
		{
			event: 'add_to_cart',
			data: {
				items: [
					{
						item_id: lesson.grade.id,
						item_name: lesson.grade.name,
						item_brand: lesson.center.name,
						item_category: `${lesson.term.name}, ${lesson.term.schoolYear}`,
						quantity: quantity,
						price: unitPrice
					}
				]
			},
			platform: 'GA'
		}
	]
});

export const startIndividualConsultationEnrolment = ({ center, consultationType, currency, total }) => ({
	type: START_INDIVIDUAL_CONSULTATION_ENROLMENT,
	analytics: [
		{
			event: 'AddToCart',
			data: {
				currency,
				value: total,
				contents: [
					{ id: `Individual_Consultation_${consultationType}`, quantity: 1 }
				],
				content_name: consultationType,
				num_items: 1
			},
			platform: 'FB'
		},
		{
			event: 'add_to_cart',
			data: {
				items: [
					{
						item_id: `Individual_Consultation_${consultationType}`,
						item_name: consultationType,
						item_brand: center && center.name,
						item_category: 'Individual_Consultation',
						quantity: 1,
						price: total
					}
				]
			},
			platform: 'GA'
		}
	]
});

export const startWorkshopEnrolment = ({ workshop, center, quantity }) => ({
	type: START_WORKSHOP_ENROLMENT,
	analytics: [
		{
			event: 'AddToCart',
			data: {
				contents: [
					{ id: `Workshop_${workshop && workshop.id}`, quantity }
				],
				content_name: workshop && workshop.name,
				num_items: quantity
			},
			platform: 'FB'
		},
		{
			event: 'add_to_cart',
			data: {
				items: [
					{
						item_id: `Workshop_${workshop && workshop.id}`,
						item_name: workshop && workshop.name,
						item_brand: center && center.name,
						item_category: 'Workshop',
						quantity: quantity,
						price: 0
					}
				]
			},
			platform: 'GA'
		}
	]
});


export const selectConsultationDate = date => ({
	type: SELECT_CONSULTATION_DATE,
	payload: date
});

export const selectCenter = centerId => ({
	type: SELECT_CENTER,
	payload: centerId
});

export const selectTerm = termId => ({
	type: SELECT_TERM,
	payload: termId
});

export const selectGrade = gradeId => ({
	type: SELECT_GRADE,
	payload: gradeId
});

export const selectLessonType = lessonType => ({
	type: SELECT_LESSON_TYPE,
	payload: lessonType
});

export const validateBookingOptions = ({ programId, date, childId, lessonType, paymentType, isPrepaid, paymentMethodName, isBonusLesson, annualPaymentLength, isSelectJoinWaitingList, campaignTags }, history) => (dispatch, getState) => {
	dispatch(loadBookingOptions({
		programId,
		date,
		childId,
		lessonType
	}))
		.then(() => {
			const newState = getState();
			if (!newState.booking.errorMessage && newState.booking.childrenPaymentTypes.find(x => x.childId === childId && x.paymentTypes.find(p => p.id === paymentType && (!annualPaymentLength || p.annualPaymentLength === annualPaymentLength)))) {
				dispatch(saveBooking({
					childId,
					programId,
					startDate: date,
					paymentType,
					isPrepaid,
					paymentMethodName,
					isBonusLesson,
					annualPaymentLength,
					campaignTags
				}, history));
			}
			else if (!newState.booking.errorMessage && isSelectJoinWaitingList && newState.booking.childrenPaymentTypes.find(x => x.childId === childId && x.joinWaitingList)) {
				dispatch(joinWaitingList({
					childId,
					programId,
					startDate: date
				}, history));
			}
		});
};

export const saveBooking = ({ childId, programId, startDate, paymentType, isPrepaid, paymentMethodName, isBonusLesson, annualPaymentLength, campaignTags }, history, rootPath = '') => ({
	[CALL_API]: {
		types: [BOOKING_CREATE_REQUEST, BOOKING_CREATE_SUCCESS, BOOKING_CREATE_FAILURE],
		endpoint: `api/booking`,
		method: 'POST',
		request: { childId, programId, startDate, paymentType, isPrepaid, paymentMethodName, isBonusLesson, annualPaymentLength, campaignTags },
		transition: {
			history,
			success: {
				push: true,
				path: response => {
					switch (response.status) {
						case 'Complete':
							return `${rootPath}complete`;			// path relative to '/booking/'
						case 'Saved':
							return `${rootPath}confirm/${response.paymentId}`;
						default:
							return '';
					}
				}
			},
			error: {
				push: true,
				path: `${rootPath}complete`
			}
		}
	}
});

export const saveIndividualConsultationBooking = ({ childId, centerId, consultationDate, paymentMethodName, campaignTags }, history, rootPath = '') => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_CREATE_REQUEST, INDIVIDUAL_CONSULTATION_CREATE_SUCCESS, INDIVIDUAL_CONSULTATION_CREATE_FAILURE],
		endpoint: `api/booking/individualConsultation`,
		method: 'POST',
		request: { childId, centerId, consultationDate, paymentMethodName, campaignTags },
		transition: {
			history,
			success: {
				push: true,
				path: response => {
					switch (response.status) {
						case 'Complete':
							return `${rootPath}complete`;		// path relative to '/individual-consultation/booking/' or '/booking/'
						case 'Saved':
							return `${rootPath}confirm/${response.paymentId}`;
						default:
							return '';
					}
				}
			},
			error: {
				push: true,
				path: `${rootPath}complete`
			}
		}
	}
});

export const saveWorkshopBooking = ({ childId, workshopId, sessionIds, paymentMethodName, campaignTags }, history, rootPath = '') => ({
	[CALL_API]: {
		types: [WORKSHOP_BOOKING_CREATE_REQUEST, WORKSHOP_BOOKING_CREATE_SUCCESS, WORKSHOP_BOOKING_CREATE_FAILURE],
		endpoint: `api/booking/workshop`,
		method: 'POST',
		request: { childId, workshopId, sessionIds, paymentMethodName, campaignTags },
		transition: {
			history,
			success: {
				push: true,
				path: response => {
					switch (response.status) {
						case 'Complete':
							return `${rootPath}complete`;		// path relative to '/workshop/booking/{centerId}/{workshopId}'
						case 'Saved':
							return `${rootPath}confirm/${response.paymentId}`;
						default:
							return '';
					}
				}
			},
			//error: {
			//    push: true,
			//    path: 'complete'
			//}
		}
	}
});

export const selectJoinWaitingList = () => ({
	type: SELECT_JOIN_WAITING_LIST
});

export const joinWaitingList = ({ childId, programId, startDate }, history) => ({
	[CALL_API]: {
		types: [WAITING_LIST_JOIN_REQUEST, WAITING_LIST_JOIN_SUCCESS, WAITING_LIST_JOIN_FAILURE],
		endpoint: `api/booking/waitingList`,
		method: 'POST',
		request: { childId, programId, startDate },
		transition: {
			history,
			success: {
				push: true,
				path: 'complete'
			},
			error: {
				push: true,
				path: 'complete'
			}
		}
	}
});

export const initiatePayment = ({ paymentId, paymentMethod }, history) => (dispatch, getState) => {
	return dispatch(initiatePaymentWithMethod(paymentMethod))
		.then(
			(paymentMethodData) =>
				dispatch({
					[CALL_API]: {
						types: [PAYMENT_START_REQUEST, PAYMENT_START_SUCCESS, PAYMENT_START_FAILURE],
						endpoint: `api/booking/payment`,
						method: 'POST',
						request: { paymentId, paymentMethodName: paymentMethod && paymentMethod.name, ...paymentMethodData },
						transition: {
							history,
							success: {
								push: true,
								path: response => {
									if (response.clientAuthorizationToken) {
										return ''; // stay on the same page to allow Stripe to confirm the payment with client secret
									}

									if (response.requiresRedirection) {
										return response.redirectUrl;
									}

									return `../process/${response.paymentId}`;
								},
								isExternal: true
							},
							error: {
								push: true,
								path: '../complete'
							}
						},
						onSuccess: response => {
							// confirm Stripe payment with a client secret
							if (response.clientAuthorizationToken) {
								return dispatch(confirmPaymentWithMethod(paymentMethod, response.clientAuthorizationToken, response.returnUrl))
									.then(() => history.push(`../process/${response.paymentId}`),
										error => {
											dispatch({ type: PAYMENT_START_FAILURE, errorResponse: { message: error.message } });
											dispatch(cancelPaymentMethod(paymentId));
										});
							}
						}
					}
				}),
			error => dispatch({ type: PAYMENT_START_FAILURE, errorResponse: { message: error || i18n.t('FO_Booking_PaymentMethodError') } })
		);
};

export const processPayment = (options, history) => ({
	[CALL_API]: {
		types: [PAYMENT_END_REQUEST, PAYMENT_END_SUCCESS, PAYMENT_END_FAILURE],
		successPayload: response => {
			const fbEventData = {
				currency: response.paymentCurrency,
				value: response.paymentTotal,
				contents: [
					{ id: response.paymentItem.id, quantity: response.paymentQuantity }
				],
				content_name: response.paymentItem.name,
				num_items: response.paymentQuantity
			};

			const gaEventData = {
				transaction_id: response.paymentId,
				value: response.paymentTotal,
				currency: response.paymentCurrency,
				tax: response.paymentTax,
				shipping: 0,
				items: [
					{
						affiliation: 'Booking Autopilot',
						item_id: response.paymentItem.id,
						item_name: response.paymentItem.name,
						item_brand: response.paymentItem.brand,
						item_category: response.paymentItem.category,
						quantity: response.paymentQuantity,
						price: response.paymentItem.price
					}
				]
			};

			if (response.paymentPromoCode) {
				gaEventData.items[0].coupon = response.paymentPromoCode;
			}

			return {
				analytics: [
					{ event: 'CompletedBooking', data: fbEventData, platform: 'FB', isCustomEvent: true },
					{ event: response.paymentType === 'Trial' ? 'StartTrial' : 'Purchase', data: fbEventData, platform: 'FB', isCustomEvent: response.paymentType === 'Trial' },
					{ event: 'purchase', data: gaEventData, platform: 'GA' }
				]
			};
		},
		endpoint: `api/booking/process`,
		method: 'POST',
		request: options,
		transition: {
			history,
			success: {
				push: true,
				path: response => {
					if (response.requiresRedirection) {
						if (!response.httpBodyParams) {
							return response.redirectUrl;
						} else {
							// stay on the same page and redirect through POST request (ePay)
							return '';
						}
					}

					return `../complete/${response.paymentId}`;		// path relative to '/individual-consultation/booking/process/{id}' or '/booking/process/{id}'
				},
				isExternal: true
			},
			error: {
				push: true,
				path: '../complete'
			}
		}
	}
});

export const paymentCancelled = reason => ({
	type: PAYMENT_CANCELLED,
	payload: reason
});

export const cancelPaymentMethod = (paymentId, paymentType = null, history = null) => dispatch => {
	dispatch({
		[CALL_API]: {
			types: [PAYMENT_CANCEL_REQUEST, PAYMENT_CANCEL_SUCCESS, PAYMENT_CANCEL_FAILURE],
			endpoint: `api/booking/cancel`,
			method: 'POST',
			request: { paymentId },
			transition: history && {
				history,
				success: {
					push: true,
					path: `../confirm/${paymentId}`, // start over with a new payment method
				},
				//error: {
				//    push: true,
				//    path: '../complete'
				//}
			},
			onError: () => {
				// payment is already Processed and cannot be cancelled - create a copy and go to /confirm page for the new payment
				dispatch(copyPayment(paymentId, paymentType, history, '../'));	// path relative to '/booking/cancelled/{id}'
			}
		}
	});
};

export const applyPromoCode = ({ paymentId, promoCode, paymentType }) => dispatch => {
	dispatch({
		[CALL_API]: {
			types: [APPLY_PROMO_CODE_REQUEST, APPLY_PROMO_CODE_SUCCESS, APPLY_PROMO_CODE_FAILURE],
			endpoint: `api/booking/promoCode`,
			method: 'POST',
			request: { paymentId, promoCode },
			onSuccess: () => dispatch(fetchPayment(paymentId, paymentType))
		}
	});
};

export const removePromoCode = ({ paymentId, promoCode, paymentType }) => dispatch => {
	dispatch({
		[CALL_API]: {
			types: [REMOVE_PROMO_CODE_REQUEST, REMOVE_PROMO_CODE_SUCCESS, REMOVE_PROMO_CODE_FAILURE],
			endpoint: `api/booking/promoCode`,
			method: 'DELETE',
			request: { paymentId, promoCode },
			onSuccess: () => dispatch(fetchPayment(paymentId, paymentType))
		}
	});
};

export const selectPaymentMethod = ({ paymentId, paymentMethod, paymentType, isInstalmentPayment, instalmentPlanTemplateId }) => dispatch => {
	dispatch({
		[CALL_API]: {
			types: [PAYMENT_METHOD_SELECT_REQUEST, PAYMENT_METHOD_SELECT_SUCCESS, PAYMENT_METHOD_SELECT_FAILURE],
			endpoint: `api/booking/paymentMethod`,
			method: 'POST',
			request: { paymentId, paymentMethodName: paymentMethod && paymentMethod.name, isInstalmentPayment, instalmentPlanTemplateId },
			onSuccess: () => dispatch(fetchPayment(paymentId, paymentType))
		}
	});
};

// save a new payment initialised from an existing payment
export const copyPayment = (paymentId, paymentType, history, rootPath) => (dispatch, getState) => {
	if (paymentType) {
		dispatch(fetchPayment(paymentId, paymentType))
			.then(() => {
				const payment = getState().entities.payments[paymentId];
				switch (paymentType) {
					case PaymentTypes.Lesson:
						dispatch(saveBooking({
							childId: payment.childId,
							programId: payment.lesson.id,
							startDate: payment.startDate,
							paymentType: payment.paymentType,
							//isPrepaid,
							//isBonusLesson,
							campaignTags: payment.campaignTags
						}, history, rootPath))
						break;
					case PaymentTypes.IndividualConsultation:
						dispatch(saveIndividualConsultationBooking({
							childId: payment.childId,
							centerId: payment.centerId,
							consultationDate: payment.consultationDate,
							campaignTags: payment.campaignTags
						}, history, rootPath));
						break;
					case PaymentTypes.Workshop:
						dispatch(saveWorkshopBooking({
							childId: payment.childId,
							workshopId: payment.workshopId,
							sessionIds: payment.workshopSessionIds,
							campaignTags: payment.campaignTags
						}, history, rootPath));
						break;
					default:
						break;
				}
			});
	}
}